import * as React from 'react';

export interface IFieldBlurificatorProps<T> {
  value: T;
  generator(
    value: T,
    onChange: (value: T) => void,
    onBlur: () => void,
  ): // tslint:disable-next-line:no-any
  React.ReactElement<any>;
  onChange(value: T): void;
}

export interface IFieldBlurificatorState<T> {
  value: T;
}

export class FieldBlurificator<T> extends React.Component<IFieldBlurificatorProps<T>, IFieldBlurificatorState<T>> {
  public constructor(props: IFieldBlurificatorProps<T>) {
    super(props);

    this.state = {
      value: props.value,
    };
  }

  public componentWillReceiveProps(nextProps: IFieldBlurificatorProps<T>) {
    this.setState({
      value: nextProps.value,
    });
  }

  public render() {
    return this.props.generator(this.state.value, this.onChange, this.onBlur);
  }

  private onChange = (value: T) => this.setState({ value });
  private onBlur = () => this.props.onChange(this.state.value);
}
